import {ReactNode} from 'react'
import {MenuComponent} from '../assets/ts/components'

type WithChildren = {
  children?: ReactNode
}

const REINIT_DELAY_MS = 500

let pendingReinit: ReturnType<typeof setTimeout> | undefined

// Re-initialises the Metronic menus once the page has settled. A call while
// an earlier one is still waiting replaces it, so a burst of navigations
// costs one whole-document scan, not one per call (ADR-0022).
const reInitMenu = () => {
  if (pendingReinit !== undefined) clearTimeout(pendingReinit)
  pendingReinit = setTimeout(() => {
    pendingReinit = undefined
    MenuComponent.reinitialization()
  }, REINIT_DELAY_MS)
}

export {type WithChildren, reInitMenu, REINIT_DELAY_MS}
